import React from 'react';
import PlaylistForm from './PlaylistForm';

const PlaylistCreate = () => {
  return <PlaylistForm mode="create" />;
};

export default PlaylistCreate;
